import React from "react";
import { ArrowRight, CircleCheck, Code, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AdvancedPackageOverview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="advanced-package-overview" className="relative flex min-h-[85vh] w-full items-center justify-center overflow-hidden dark bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <video autoPlay loop muted playsInline poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569073/img/developer_workspace_poster.png" className="h-full w-full object-cover opacity-40">
          <source src="/videos/developer_workspace.mp4" type="video/mp4" />
        </video>
        
        <div className="absolute inset-0 bg-gradient-to-b from-background/80 via-background/60 to-background/90 backdrop-blur-[2px]" />
        
        {}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[500px] w-[500px] rounded-full bg-primary/20 blur-[120px]" />
      </div>

      {}
      <div ref={ref} className={`relative z-10 container mx-auto px-4 text-center transition-all duration-1000 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
        {}
        <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-primary/30 bg-primary/10 px-4 py-1.5 text-sm font-medium text-primary backdrop-blur-md">
          <Zap className="h-4 w-4 fill-primary/20" />
          <span className="tracking-wide uppercase">Most Popular Choice</span>
        </div>

        {}
        <h1 className="max-w-4xl font-sans text-5xl font-extrabold tracking-tight text-white ![margin:35px_0px_24px_0px] sm:text-6xl md:text-7xl lg:text-8xl">
          Advanced <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-teal-200">Website Package</span>
        </h1>

        {}
        <p className="mx-auto mb-10 max-w-2xl text-lg text-muted-foreground md:text-xl">
          A complete digital solution for growing businesses. Includes custom design, SEO optimisation, and premium support to help you scale.
        </p>

        {}
        <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
          <Button asChild size="lg" className="h-14 rounded-full bg-primary px-8 text-lg font-bold text-primary-foreground shadow-[0_0_20px_-5px_var(--color-primary)] transition-transform hover:scale-105 hover:shadow-[0_0_30px_-5px_var(--color-primary)]">
            <Link to="/ContactPage">
              $1400 - Get Started
            </Link>
          </Button>
          
          <Button asChild variant="outline" size="lg" className="h-14 rounded-full border-white/10 bg-white/5 px-8 text-lg text-white backdrop-blur-sm hover:bg-white/10 hover:text-white">
            <Link to="/PackagesPage" className="inline-flex items-center gap-2">
              View Packages <ArrowRight className="h-5 w-5" />
            </Link>
          </Button>
        </div>

        {}
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 text-sm font-medium text-muted-foreground/80 ![margin:64px_0px_10px_0px]">
          <div className="flex items-center gap-2">
            <CircleCheck className="h-4 w-4 text-primary" />
            <span>5 Custom Pages</span>
          </div>
          <div className="flex items-center gap-2">
            <CircleCheck className="h-4 w-4 text-primary" />
            <span>SEO Optimised</span>
          </div>
          <div className="flex items-center gap-2">
            <CircleCheck className="h-4 w-4 text-primary" />
            <span>Mobile Responsive</span>
          </div>
          <div className="flex items-center gap-2">
            <Code className="h-4 w-4 text-primary" />
            <span>Fast Turnaround</span>
          </div>
        </div>
      </div>
    </section>;
}